import { render, staticRenderFns } from "./AdminSettingsSetupChecks.vue?vue&type=template&id=ec87bd90"
import script from "./AdminSettingsSetupChecks.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminSettingsSetupChecks.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AdminSettingsSetupChecks.vue?vue&type=style&index=0&id=ec87bd90&prod&scope=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports